module.exports = __webpack_public_path__ + "img/hr-red-croton-05.68cde2be.png";